<template>
  <organism-edit-service-data
    v-if="isLoading"
    :originServiceDetail="originServiceDetail"
    @updateNewService="onSendRequestToUpdateServiceDetail"
  ></organism-edit-service-data>
</template>

<script>
import { getServiceById, updateServiceDetail } from "@/api/api-module1"
import mixins from "@/mixins"
import OrganismEditServiceData from "@/components/organisms/globalSetting/dataManagement/service/OrganismEditServiceData.vue"

export default {
  name: "EditServiceData",
  components: {
    OrganismEditServiceData,
  },
  mixins: [mixins],
  data() {
    return {
      originServiceDetail: null,
      selectedPackage: null,
    }
  },
  computed: {
    isLoading() {
      return Boolean(this.originServiceDetail)
    },

    serviceId() {
      return this.$route?.params?.serviceId
    },
  },

  mounted() {
    this.fetchDataFromApi()
  },

  methods: {
    async fetchDataFromApi() {
      this.showLoading(true)
      await getServiceById(this.serviceId)
        .then((response) => {
          this.originServiceDetail = {
            ...response,
            packages: response.packages.map((packageItem, index) => {
              return {
                packageId: packageItem.packageId,
                packageName: packageItem.packageName,
                deprecated: packageItem.deprecated,
                isSelected: index === 0,
                details: packageItem.details.map((item) => {
                  return {
                    period: item.packageItemName,
                    info: item.packageSubItem,
                    sequence: item.sequence,
                  }
                }),
                periods: packageItem.periods.map((item) => {
                  return {
                    id: item.packagePeriodId,
                    period: item.packagePeriodName,
                    info: item.price,
                    sequence: item.sequence,
                  }
                }),
                options: packageItem.options.map((item) => {
                  return {
                    id: item.packageOptionId,
                    period: item.packageOptionName,
                    info: item.price,
                    sequence: item.sequence,
                  }
                }),
              }
            }),
          }
        })
        .finally(() => this.showLoading(false))
    },

    async onSendRequestToUpdateServiceDetail(serviceDetail, packageName) {
      this.showLoading(true)
      await updateServiceDetail(this.serviceId, serviceDetail)
        .then(async (response) => {
          if (response) {
            this.toastSuccess("Updated Service Detail Successfully")
            await this.fetchDataFromApi()
            if (!packageName) {
              this.selectedPackage = null
            } else {
              this.selectedPackage = this.originServiceDetail.packages.find(
                (targetPackage) => targetPackage.packageName === packageName
              )
            }
          }
        })
        .catch((error) => {
          if (error.response.data.ErrorCode === "IN_USE") {
            this.toastError(error.response.data.ErrorMessage)
          } else {
            this.toastError("Updated Service Detail Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
